// extracted by mini-css-extract-plugin
module.exports = {"externalLinkLayout":"ExternalLinks_externalLinkLayout__88_lM","GridSystem":"ExternalLinks_GridSystem__1u9vZ"};